import { defineStore } from "pinia";
export const useKeepAliveStore = defineStore("keepAlive", {
  state: () => ({
    include: [],
  }),
  actions: {
    async addInclude(val) {
      if (this.include.includes(val)) {
        return;
      }
      this.include.push(val);
    },
    rmInclude(val) {
      const index = this.include.indexOf(val);
      if (index !== -1) {
        this.include.splice(index, 1);
      }
    },
  },
});
